module.exports = __webpack_public_path__ + "img/r-151.dacc1f56.jpg";